/**
 * Utilitaires de chiffrement/déchiffrement pour les tokens
 *
 * Ce module fournit des fonctions simples pour sécuriser les tokens
 * stockés dans le localStorage en utilisant un chiffrement basé sur base64
 * avec rotation de caractères.
 */

/**
 * Chiffre un token en utilisant base64 + rotation de caractères
 * @param {string} token - Token à chiffrer
 * @returns {string} Token chiffré
 */
export const encryptToken = (token) => {
  // Chiffrement simple avec base64 + rotation de caractères
  const encoded = btoa(token);
  return encoded.split("").reverse().join("");
};

/**
 * Déchiffre un token chiffré
 * @param {string} encryptedToken - Token chiffré
 * @returns {string} Token déchiffré
 * @throws {Error} Si le token chiffré est invalide
 */
export const decryptToken = (encryptedToken) => {
  try {
    // Déchiffrement inverse
    const reversed = encryptedToken.split("").reverse().join("");
    return atob(reversed);
  } catch (error) {
    throw new Error("Token chiffré invalide");
  }
};

/**
 * Vérifie si un token chiffré est valide
 * @param {string} encryptedToken - Token chiffré à vérifier
 * @returns {boolean} True si le token est valide
 */
export const isValidEncryptedToken = (encryptedToken) => {
  try {
    decryptToken(encryptedToken);
    return true;
  } catch (error) {
    return false;
  }
};
